import { AppDispatcher } from 'services/PubSub';
import { actionsType } from 'config/constants';
import FavoritesService from 'services/Favorites'
import TagManagerService from 'services/TagManager';
import CatalogService from 'services/Catalog';
import { features } from 'config';

let skus = [];
let FavoritesSkus = [];

const updateFavorites = (_skus) => {
    const _favorites = FavoritesSkus ? FavoritesSkus : [];

    let newFavorites = _favorites.concat(_skus.filter(sku => sku.action === "add").map(item => item.sku))
    let removeFavorites = _skus.filter(sku => sku.action === "remove").map(item => item.sku)
    const tmpPayload = newFavorites.filter(favorite => !removeFavorites.includes(favorite))
    const payload = [...new Set(tmpPayload)]
    FavoritesSkus = payload;

    return FavoritesService.updateFavorites(payload)
        .then((response) => {
            if(response){
                AppDispatcher.dispatch({
                    type: actionsType.UPDATE_FAVORITES,
                    payload
                })
                skus = []
            }
        }, () => {
            return false
        })
}

const _sendFavorites = (items) => {
    actions.setLoading(false);
    FavoritesSkus = items;
    AppDispatcher.dispatch({
        type: actionsType.UPDATE_FAVORITES,
        payload: items,
    })
    return items
}

const actions = {
    setLoading: (value) => {
        setTimeout(() => {
            AppDispatcher.dispatch({
                type: actionsType.SET_LOADING_FAVORITES,
                payload: value
            });
        }, 0);
    },
    getFavorites(orderPersonalize = true) {
        actions.setLoading(true);
        return FavoritesService.getFavorites()
            .then(response => {
                if(features.personalize && orderPersonalize) {
                    response = response ? response.slice(0, 499).toString() : [];
                    return CatalogService.getOrderRanking(response).then(items => {
                        return _sendFavorites(items)
                    })
                }else {
                    return _sendFavorites(response)
                } 
            })
    },
    addFavorite(sku) {
        skus.push({sku, action: 'add'});
        TagManagerService.interaction('Agregar Favorito', sku,  'Productos Favoritos');
        return updateFavorites(skus)
    },
    removeFavorite(sku) {
        skus.push({sku, action: 'remove'})
        TagManagerService.interaction('Remover Favorito', sku,  'Productos Favoritos');
        return updateFavorites(skus)
    }
}

export default actions